import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import appStatusStore from '@/store/applicationStatus.store.ts';
import { StatusStateMap } from '@/components/common/StatusIcon/statusIcon';
import { ROUTE_NAME_SIGN_IN } from '@/config/routeNames';

const TEST_NAME = '__sirta_cookie_test__';
const TEST_VALUE = '1';

export function areCookiesEnabled(): boolean {
  if (typeof navigator !== 'undefined' && !navigator.cookieEnabled) {
    return false;
  }

  try {
    document.cookie = `${TEST_NAME}=${TEST_VALUE}; path=/; SameSite=Strict`;
    const stored = document.cookie
      .split(/;\s*/)
      .some(cookie => cookie === `${TEST_NAME}=${TEST_VALUE}`);
    document.cookie = `${TEST_NAME}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict`;
    return stored;
  } catch {
    return false;
  }
}

export function notifyCookiesDisabled(): void {
  appStatusStore().openApplicationStatus({
    status: StatusStateMap.Error,
    content: 'commonComponents.cookieEnabledValidator.message',
  });
}

export default function useCookieValidation() {
  const router = useRouter();

  onMounted(async () => {
    if (areCookiesEnabled()) {
      return;
    }

    if (router.currentRoute.value.name !== ROUTE_NAME_SIGN_IN) {
      await router.push({ name: ROUTE_NAME_SIGN_IN });
    }

    notifyCookiesDisabled();
  });
}
